document.querySelectorAll('.activate-tab').forEach(item => {
    item.addEventListener('click', event => {
      event.preventDefault();

      const targetId = event.target.getAttribute('data-target').replace('#', '');
      const targetTab = document.getElementById(targetId);
      const activeTab = document.querySelector('.YSWTabs__content-tab--active');

      if (!targetTab || !activeTab) return;

      activeTab.classList.remove('YSWTabs__content-tab--active');
      activeTab.setAttribute('hidden', 'true');

      targetTab.removeAttribute('hidden');
      targetTab.classList.add('YSWTabs__content-tab--active');

      document.querySelectorAll('.YSWTabs__list-item').forEach(link => {
        link.classList.remove('YSWTabs__list-item--active');
      });

      const targetNavItem = document.querySelector(`[data-target="#${targetId}"]`);
      if (targetNavItem) {
        targetNavItem.closest('li').classList.add('YSWTabs__list-item--active');
      }
    });
  });

  document.querySelectorAll('.YSWTabs__list-item .YSWTabs__item').forEach(tab => {
    tab.addEventListener('click', event => {
      const targetId = event.target.getAttribute('data-target').replace('#', '');
      const targetTab = document.getElementById(targetId);

      if (targetTab) {
        targetTab.removeAttribute('hidden');
      }
    });
  });
